import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {Judol, JudolQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/report/judol`

const getJudol = (query: string): Promise<JudolQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<JudolQueryResponse>) => d.data)
}

const getJudolById = (id: ID): Promise<Judol | undefined> => {
  return axios
    .get(`${URL}/${id}`)
    .then((response: AxiosResponse<Response<Judol>>) => response.data)
    .then((response: Response<Judol>) => response.data)
}

const createJudol = (value: Judol): Promise<Judol | undefined> => {
  return axios
    .post(`${URL}`, value)
    .then((response: AxiosResponse<Response<Judol>>) => response.data)
    .then((response: Response<Judol>) => response.data)
}

const updateJudol = (value: Judol): Promise<any | undefined> => {
  return axios
    .put(`${URL}/${value.id}`, value)
    .then((response: AxiosResponse<Response<Judol>>) => response.data)
    .then((response: Response<Judol>) => response.data)
}

const deleteJudol = (id: ID): Promise<void> => {
  return axios.delete(`${URL}/${id}`).then(() => {})
}

const verifyJudol = (id: ID): Promise<void> => {
  return axios.put(`${URL}/verify/${id}`).then(() => {})
}

const rejectJudol = (id: ID): Promise<void> => {
  return axios.put(`${URL}/reject/${id}`).then(() => {})
}

const setDraftJudol = (id: ID): Promise<void> => {
  return axios.put(`${URL}/set-draft/${id}`).then(() => {})
}

export {getJudol, getJudolById, updateJudol, deleteJudol, createJudol, verifyJudol, rejectJudol, setDraftJudol}
